module.exports = __webpack_public_path__ + "img/subscription.8b346af9.png";